import React from 'react'
import Element from './Element'
import {PageProvider} from '../PocketHitsShared/page-context';
import { state } from '../PocketHitsShared/state';

const { newsletterPage, captcha } = state

export default () => (
    <PageProvider {...newsletterPage} captcha={captcha}>
      <Element initialSignedParams={null} />
    </PageProvider>
)
